import styles from "./styles.module.scss";
import { _ } from "i18n";
import { AIEarlyAccessTag } from "common/src/ai/components/early-access-tag";
import { CoachReviewsAIGenerateButton } from "../AIGenerateButton";
import { CoachReviewsDisabledTeam, CoachReviewsTeam } from "../Team";
import { CoachReviewsPlayerList } from "../PlayerList";
import { AICoachReviewsMode } from "common/src/gamePage/types";
import { useGetReviews } from "common/src/gamePage/hooks/useGetReviews";
import { CoachReviewsCopyLinkButton } from "../CopyLinkButton";

export const CoachReviewsContainer = () => {
	const { data, isLoading, isError } = useGetReviews();

	// TODO: Loading state
	if (isLoading) return null;

	// TODO: Error state
	if (isError) return null;

	const { aiGenerationAvailable } = data.data;

	const excludeTeamReview = Boolean(data.data.team.review);
	// Players with a sent review or without eligibility will not be AI generated
	const excludePlayerIds = data.data.players
		.filter((player) => Boolean(player.review) || player.reviewEligibility.isEligible === false)
		.map((player) => player.gamePlayerId);
	const hasAnyEligiblePlayers = data.data.players.some((player) => player.reviewEligibility.isEligible);

	return (
		<div className={styles["reviews"]}>
			{!hasAnyEligiblePlayers && (
				<div className={styles["reviews__no-players"]}>
					<p className={styles["reviews__no-players-title"]}>{_("game.coachReviews.container.noEligiblePlayers.title")}</p>
					<p className={styles["reviews__no-players-description"]}>{_("game.coachReviews.container.noEligiblePlayers.description")}</p>
					<CoachReviewsCopyLinkButton lookAs="button" />
				</div>
			)}
			<AIEarlyAccessTag />
			<h3 className={styles["reviews__title"]}>{_("game.coachReviews.container.title")}</h3>
			{aiGenerationAvailable && (
				<CoachReviewsAIGenerateButton
					mode={AICoachReviewsMode.All}
					excludePlayerIds={excludePlayerIds}
					excludeTeamReview={excludeTeamReview}
					disabled={!hasAnyEligiblePlayers}
				/>
			)}
			<div className={styles["reviews__team"]}>
				{hasAnyEligiblePlayers ? <CoachReviewsTeam /> : <CoachReviewsDisabledTeam teamName={data.data.team.teamName || ""} />}
			</div>
			<CoachReviewsPlayerList />
		</div>
	);
};
